import { AfterViewInit, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, Directive } from '@angular/core';
import {FilterPanelHandler} from '../model/filter-panel-handler.model';
import {FilterPanel} from '../model/filter-panel.model';
import {DecimalPipe} from '@angular/common';
import {HomeSearchFiltersAnalyticsHandler} from '../home-search-filters-analytics-handler';
import { MinMax, RangeInputComponent } from './range-input/range-input.component';

@Directive()
export class RangeTypeFilter implements OnInit, AfterViewInit {

  @ViewChild('clearTemplate') clearTemplate: TemplateRef<any>;
  @ViewChild('rangeInput') rangeFilter: RangeInputComponent;

  @Input() panel: FilterPanel;

  @Input() value: MinMax = {min: '', max: ''};
  @Output() valueChange: EventEmitter<MinMax> = new EventEmitter<MinMax>();
  @Output() cleanValue: EventEmitter<MinMax> = new EventEmitter<MinMax>();

  originalPanelName = '';
  panelHandler: FilterPanelHandler;

  constructor(
    private googleAnalyticsEventManager: HomeSearchFiltersAnalyticsHandler
  ) {}

  ngOnInit() {
    this.panelHandler = new FilterPanelHandler(this.panel);
    this.originalPanelName = this.panel.name;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.panelHandler.setPanelExtraTemplate(this.clearTemplate);
      this.setPanelHeader();
    }, 0);
  }

  cleanFilter(evt: MouseEvent) {
    evt.stopPropagation();
    this.rangeFilter.form.reset({min: '', max: ''});
    this.cleanValue.emit(this.value);
  }

  emit(v: MinMax) {
    this.value = v;
    this.valueChange.emit(v);
    this.setPanelHeader();
  }

  setPanelHeader() {
    const suffix = this.rangeFilter.maxPrefix;
    const decimalPipe = new DecimalPipe('pt-BR');
    const minStr = decimalPipe.transform(this.value.min, '') || '';
    const maxStr = decimalPipe.transform(this.value.max, '') || '';

    this.panelHandler.setPanelHeader(
      this.getValue(suffix, minStr, maxStr)
    );
  }

  getValue(suffix: string, minStr: string, maxStr: string): string {
    const label = this.originalPanelName;

    if (!this.hasValue()) {
      return label;
    }

    if (!minStr) {
      return `${label} máx. ${suffix} ${maxStr}`;
    }

    if (!maxStr) {
      return `${label} mín. ${suffix} ${minStr}`;
    }

    return `${label} ${suffix} (${minStr} - ${maxStr})`;
  }

  hasValue(): boolean {
    return !!(this.value.min || this.value.max);
  }

  sendEvent(fieldName: string, blurEvent: any): void {
    const field = `${fieldName}-${blurEvent.field}`;

    this.googleAnalyticsEventManager.sendEvent(`${field}:${blurEvent.value}`);

    if (blurEvent.error.hasError) {
      this.googleAnalyticsEventManager.sendEvent(`${field}:${blurEvent.error.message}`);
    }
  }
}
